export default __webpack_public_path__ + "static/rec-s5-66fe5a9295fce3f894147f152474f31e.png";